import { useMemo, useState } from 'react';
import { GqlIpInfo, useGeolocateConsumerQuery } from 'types/graphql';

export default function useGeoinfo(): [GqlIpInfo | null, (region: string) => void] {
  const [regionOverride, setRegionOverride] = useState<string | null>(null);

  const { data } = useGeolocateConsumerQuery({ skip: process.env.NODE_ENV === 'test' });
  const geoinfo = data?.geolocate;
  const geoinfoWithRegionOverride = useMemo(
    () => (geoinfo && regionOverride ? { ...geoinfo, region: regionOverride } : geoinfo),
    [geoinfo, regionOverride]
  );

  function setRegion(region: string): void {
    setRegionOverride(region);
  }
  return [geoinfoWithRegionOverride ?? null, setRegion];
}
